import { createRestConnectionForm } from "./rest-connection-form";
import { ODATA_SPEC } from "./rest-connection-specs";

/** OData. Everything but the spec lives in `rest-connection-form.tsx`. */
const createConnectionOData = createRestConnectionForm(ODATA_SPEC);
export { createConnectionOData as CreateConnectionOData };
